// src/slices/filtersSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColumnFilterItem } from "antd/es/table/interface";

interface FilterState {
  filters: {
    page: number;
    page_size: number;
    unmatchedInLc?: string[];
    status?: string[];
    type?: string[];
    maker?: string[];
    checker?: string[];
    gl?: string[];
    gl_name?: string[];
    gl_nomenclature?: string[];
    gl_group?: string[];
    account_type?: string[];
    glNomenclature?: string[];
    companies?: string[];
    glBalanceInLc?: string[];
    glBalanceInFc?: string[];
    unmatchedInFc?: string[];
    search_in: "gl" | "gl_nomenclature";
    search: string;
    action?: string[];
    sort_by?: string;
    sort_order?: string;
  };
  filterOptions: {
    gl: ColumnFilterItem[];
    gl_nomenclature: ColumnFilterItem[];
    company?: ColumnFilterItem[];
    users?: ColumnFilterItem[];
    type: ColumnFilterItem[];
  };
  otherFilters: {
    period: number;
    year: number;
  };
}

const initialState: FilterState = {
  filters: {
    page: 1,
    page_size: 100,
    search_in: "gl",
    search: "",
    gl_nomenclature: [],
    gl_group: [],
  },
  filterOptions: {
    gl: [],
    gl_nomenclature: [],
    company: [],
    users: [],
    type: [],
  },
  otherFilters: {
    period: 0,
    year: new Date().getFullYear(),
  },
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<FilterState["filters"]>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setFilterOptions: (
      state,
      action: PayloadAction<FilterState["filterOptions"]>
    ) => {
      state.filterOptions = { ...state.filterOptions, ...action.payload };
    },
    setOtherFilters: (
      state,
      action: PayloadAction<FilterState["otherFilters"]>
    ) => {
      state.otherFilters = { ...state.otherFilters, ...action.payload };
    },
  },
});

export const { setFilters, setFilterOptions, setOtherFilters } =
  filtersSlice.actions;

export default filtersSlice.reducer;
